import { Link } from "react-router-dom";
import { handleClickColor } from "../../Common/Util";

export function TransitRulingPlanet ({clientData}) {
  return(
    <table class="m-0 p-0 table table-bordered table-hover caption-top text-start">
      <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Transit Ruling Planets</h4></caption>
      <thead class="m-0 p-0">
        <tr class="m-0 p-0">
          <th class="m-0 p-1 text-center">Planet</th> 
          <th class="m-0 p-1 text-center">Sign Lord</th> 
          <th class="m-0 p-1 text-center">Star Lord</th> 
          <th class="m-0 p-1 text-center">Sub Lord</th> 
          <th class="m-0 p-1 text-center">Sub Sub Lord</th> 
          <th class="m-0 p-1 text-center">SSS Lord</th> 
        </tr>
      </thead>
      {clientData.transitSignLord===null?
      <tbody class="m-0 p-0">
        <tr class="m-0 p-0" >
          <th class="m-0 p-1 bg-transparent">Lagna</th>
          <td class="m-0 p-1 bg-transparent text-center align-middle" colSpan="5" rowSpan="2" >Add your city in <Link to="/cprofile.html">My Profile</Link> page to view Transit Ruling Planets.</td>
        </tr>
        <tr class="m-0 p-0" >
          <th class="m-0 p-1 bg-transparent">Moon</th>
        </tr>  
        <tr class="m-0 p-0" onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent">Day Lord</th>
          <td class="m-0 p-1 bg-transparent" colSpan="5">{clientData.transitDayLord}</td>
        </tr>  
      </tbody>
      :
      <tbody class="m-0 p-0">
        <tr class="m-0 p-0"  onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent">Lagna</th>
          <td class="m-0 p-1 bg-transparent">{clientData.transitCuspalSignLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.transitCuspalStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.transitCuspalSubStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.transitCuspalSubSubStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.transitCuspalSubSubSubStarLord}</td>
        </tr>  
        <tr class="m-0 p-0" onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent">Moon</th>
          <td class="m-0 p-1 bg-transparent">{clientData.transitSignLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.transitStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.transitSubStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.transitSubSubStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.transitSubSubSubStarLord}</td>
        </tr>  
        <tr class="m-0 p-0" onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent">Day Lord</th>
          <td class="m-0 p-1 bg-transparent" colSpan="5">{clientData.transitDayLord}</td>
        </tr>  
      </tbody>  
      }
    </table>
  );
}